import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity'
import { Action, createReducer, on } from '@ngrx/store'
import * as TaxesActions from './taxes.actions'
import { TaxesActionTypeEnum, TaxesEntity } from './taxes.models'

export const TAXES_FEATURE_KEY = 'taxes'

export interface TaxesState extends EntityState<TaxesEntity> {
  selectedId?: string | number
  loaded: boolean
  editCreateLoaded: boolean
}

export interface TaxesPartialState {
  readonly [TAXES_FEATURE_KEY]: TaxesState
}

export const taxesAdapter: EntityAdapter<TaxesEntity> = createEntityAdapter<TaxesEntity>({
  selectId: (tax: TaxesEntity) => tax.uuid,
})

export const initialTaxesState: TaxesState = taxesAdapter.getInitialState({
  editCreateLoaded: true,
  loaded: true,
})

const reducer = createReducer(
  initialTaxesState,
  on(TaxesActions.loadTaxes, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(TaxesActions.updateTax, (state) => ({ ...state, editCreateLoaded: false })),
  on(TaxesActions.createTax, (state) => ({ ...state, editCreateLoaded: false })),
  on(TaxesActions.taxesChangedSuccess, (state) => ({ ...state, editCreateLoaded: true })),
  on(TaxesActions.taxesChangedFailure, (state) => ({ ...state, editCreateLoaded: true })),
  on(TaxesActions.loadTaxesSuccess, (state, { taxes }) => taxesAdapter.setAll(taxes, { ...state, loaded: true })),
  on(TaxesActions.loadTaxesFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(TaxesActions.loadTaxSuccess, (state, { tax }) => taxesAdapter.upsertOne(tax, { ...state, loaded: true })),
  on(TaxesActions.taxesChangedSuccess, (state, { tax, taxActionType }) => {
    if (taxActionType === TaxesActionTypeEnum.delete) {
      return taxesAdapter.removeOne(tax.uuid, state)
    }
    return taxesAdapter.upsertOne(tax, state)
  }),
  on(TaxesActions.selectTax, (state, { taxUuid }) => ({ ...state, selectedId: taxUuid })),
  on(TaxesActions.resetEditCreateLoaded, (state) => ({ ...state, editCreateLoaded: true })),
  on(TaxesActions.clearTaxes, () => ({ ...initialTaxesState })),
)

export function taxesReducer(state: TaxesState | undefined, action: Action) {
  return reducer(state, action)
}
